// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://umnoiivuntnvsxkysvrr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVtbm9paXZ1bnRudnN4a3lzdnJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxMTQ0NDUsImV4cCI6MjA2NTY5MDQ0NX0.6I7mIhnFfQeEnnvOKIRw6SCSEdZiv3eSOWNpsDx8MH8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);